import type { ReactNode } from 'react';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import type { ButtonProps } from '@library';
import { TextBlock, Tooltip, HStack, Button, VStack } from '@library';
import CloudDownloadIcon from './icons/CloudDownloadIcon';
import ErrorInfoIcon from './icons/ErrorInfoIcon';

const FileDownloadButton = ({
    startDownload,
    requestFailed = false,
    loading = false,
    children,
    errorMessage,
    disableTooltip = false,
    icon = <CloudDownloadIcon small />,
    ...buttonProps
}: Omit<ButtonProps, 'onClick' | 'children'> & {
    startDownload(): void;
    requestFailed?: boolean;
    loading?: boolean;
    children?: ReactNode;
    disableTooltip?: boolean;
    errorMessage?: ReactNode;
    icon?: ReactNode;
}) => {
    return (
        <Tooltip
            disabled={!requestFailed || disableTooltip}
            content={
                <TextBlock secondary regular>
                    {errorMessage ? (
                        errorMessage
                    ) : (
                        <FormattedMessage id="failed to prepare your download. please try again later" />
                    )}
                </TextBlock>
            }
            placement="top"
            modal
            showArrow
        >
            <VStack>
                <Button
                    disabled={loading}
                    loading={loading}
                    {...buttonProps}
                    onClick={async () => startDownload()}
                >
                    <HStack align="center" gap="mini">
                        {requestFailed && (
                            <ErrorInfoIcon color="var(--error-color)" />
                        )}
                        {!loading && !requestFailed && icon}
                        <TextBlock secondary>{children}</TextBlock>
                    </HStack>
                </Button>
            </VStack>
        </Tooltip>
    );
};

export default memo(FileDownloadButton);
